module.exports = __webpack_public_path__ + "img/sys.f947f31a.png";